<template>
  <TopBar />
  <section class="hero-franqueado d-flex align-items-center">
  <div class="hero-overlay"></div>
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 mb-4">
          <span class="badge badge-purple">Franquia Creditall</span>
          <h1 class="display-5 fw-bold titulo-franquia">{{ textoDigitado }}</h1>
          <p class="lead valor-destaque">
  <span class="texto-vermelho">{{ textoPotencialDigitado.slice(0, 14) }}</span> <span class="texto-branco">{{ textoPotencialDigitado.slice(14) }}</span>
</p>
          <a href="#formulario" class="btn btn-primary btn-lg">Falar com consultor</a>
        </div>
      </div>
    </div>
  </section>
    <section class="solucoes-franqueado py-5">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 mb-4">
          <span class="badge badge-info mb-3">Modelos de negócio prontos para escalar</span>
          <h2 class="titulo-principal mb-3">
            Transforme ambição em conquista real
          </h2>
          <p class="fw-bold mb-2">
            Você no comando de uma operação que muda vidas e movimenta milhões.
          </p>
          <p class="mb-4">
            Com a força da Creditall, seu potencial deixa de ser plano e vira história daquelas que inspiram o mercado e fazem barulho.
          </p>
          <a href="#formulario" class="btn btn-info btn-lg mb-4">Falar com consultor &rarr;</a>
          <div>
            <span class="hashtag">#VempraCreditall</span>
          </div>
        </div>
        <div class="col-lg-6 text-center">
          <img src="assets/images/solucoes-circular.png" alt="Soluções Creditall" class="img-circular" />
        </div>
      </div>
    </div>
  </section>

<section class="jornada-empreendedora py-5">
  <div class="container">
    <h2 class="jornada-titulo mb-5">Sua jornada empreendedora começa agora com a Creditall</h2>
    <div class="row justify-content-center">
      <div class="col-md-3 col-6 mb-3">
        <div class="jornada-card">
          <div class="jornada-icon"><i class="fas fa-dollar-sign"></i></div>
          <h5>Investimento inicial</h5>
          <p>A partir de R$ 250.000,00</p>
        </div>
      </div>
      <div class="col-md-3 col-6 mb-3">
        <div class="jornada-card">
          <div class="jornada-icon"><i class="fas fa-users"></i></div>
          <h5>Alcance</h5>
          <p>+600 Mil CPF/CNPJ atendidos</p>
        </div>
      </div>
      <div class="col-md-3 col-6 mb-3">
        <div class="jornada-card">
          <div class="jornada-icon"><i class="fas fa-boxes"></i></div>
          <h5>Produtos</h5>
          <p>8 Produtos no portifólio</p>
        </div>
      </div>
      <div class="col-md-3 col-6 mb-3">
        <div class="jornada-card">
          <div class="jornada-icon"><i class="fas fa-file-signature"></i></div>
          <h5>Contratos</h5>
          <p>+15 contratos por vendedor/mês</p>
        </div>
      </div>
            <div class="col-md-3 col-6 mb-3">
        <div class="jornada-card">
          <div class="jornada-icon"><i class="fas fa-exchange-alt"></i></div>
          <h5>Transações</h5>
          <p>+4 Bilhões em crédito</p>
        </div>
      </div>
            <div class="col-md-3 col-6 mb-3">
        <div class="jornada-card">
          <div class="jornada-icon"><i class="fas fa-shield-alt"></i></div>
          <h5>Garantia</h5>
          <p>+85 Milhões garantidos</p>
        </div>
      </div>
            <div class="col-md-3 col-6 mb-3">
        <div class="jornada-card">
          <div class="jornada-icon"><i class="fas fa-comment-dots"></i></div>
          <h5>Reclamações</h5>
          <p> Nenhuma pendente</p>
        </div>
      </div>
            <div class="col-md-3 col-6 mb-3">
        <div class="jornada-card">
          <div class="jornada-icon"><i class="fas fa-chart-line"></i></div>
          <h5>Receita</h5>
          <p>+230 Milhões gerados</p>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="porque-franqueado py-5">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 text-center mb-4 mb-lg-0">
                <img src="assets/images/mapa.png" alt="Franqueado Creditall" class="img-franqueado" />
            </div>
            <div class ="col-lg-6">
                <span class="badge badge-success mb-3">A melhor franquia</span>
                <h2 class="porque titulo mb-3">Por que ser um franqueado Creditall?</h2>
                <p class="porque-desc mb3">
                  Empreenda com inovação, credibilidade e o respaldo de quem entende do mercado.
                  A Creditall oferece um modelo de negócio testado, com suporte estratégico, tecnologia própria e foco total em rentabilidade.
                </p>
                <p class="porque-desc mb3">
                  O Brasil possui mais de 10,6 milhões de empresas de pequeno porte, sociedades e outras naturezas jurídicas, exceto MEIs, que representam um imenso potencial de mercado para os serviços da Creditall. Além disso, segundo a Serasa, 73% dos brasileiros preferem parcelar suas compras do que pagar à vista, o que reforça ainda mais a demanda pelas soluções que oferecemos.
                </p>
              <ul class="porque-lista">
                <li>
                  <i class="fas fa-check-circle"></i>
                  <span class="texto-item">Soluções completas para os desafios do seu negócio</span>
                </li>
                <li>
                  <i class="fas fa-check-circle"></i>
                  <span class="texto-item">Análise de crédito inteligente e eficiente</span>
                </li>
                <li>
                  <i class="fas fa-check-circle"></i>
                  <span class="texto-item">Alta performance na concessão de crédito</span>
                </li>
                <li>
                  <i class="fas fa-check-circle"></i>
                  <span class="texto-item">Gestão voltada à inovação</span>
                </li>
                <li>
                  <i class="fas fa-check-circle"></i>
                  <span class="texto-item">Compromisso com a satisfação do cliente</span>
                </li>
                <li>
                  <i class="fas fa-check-circle"></i>
                  <span class="texto-item">Qualidade em cada etapa do processo</span>
                </li>
              </ul>
                <a href="#formulario" class="btn btn-info btn-lg mt-4">Falar com consultor &rarr;</a>
            </div>
        </div>
    </div>
</section>

<section class="unidades-creditall py-5">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6 mb-4 mb-lg-0">
        <span class="badge badge-unidades mb-3">Unidades Creditall</span>
          <h2 class="titulo-unidades mb-2">
            Encontre uma Creditall<br />
            <span class="titulo-unidades">mais próxima de você</span>
          </h2>
          <p class="desc-unidades">
            Nossas unidades oferecem atendimento consultivo, com profissionais preparados para entender suas necessidades e apresentar as melhores soluções em crédito com garantia, planos de saúde, consorcios, seguros e muito mais.
          </p>
        </div>
        <div class="col-lg-6 text-center">
            <div class="video-responsive">
              <iframe
              width="800"
              height="300"
              src="https://player.vimeo.com/video/1125589961"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              style="border-radius: 18px; box-shadow: 0 4px 24px rgba(0,0,0,0.10); width: 100%; max-width: 700px;"
              ></iframe>
            </div>
        </div>
    </div>
  </div>
</section>

<section class="franquias-creditall py-5">
  <div class="container">
    <h2 class="franquias-titulo mb-5">
      <span>FRANQUIAS</span> <span class="fraquias-destaque">& OPORTUNIDADES</span>
    </h2>
    <div class="carousel-container d-flex justify-content-center align-items-center">
      <button class="carousel-btn-elegante me-4" @click="prevFranquia" aria-label="Anterior">
        <i class="fas fa-chevron-left"></i>
      </button>
      <div class="carousel-slide text-center d-flex justify-content-center">
        <div 
          v-for="(franquia, idx) in franquiasVisiveis"
          :key="franquia.nome + idx + franquiaAtual"
          class="franquia-card mx-2 mb-3"
          :class="{
            destaque: idx === 1,
            'blur-card': cardsVisiveis > 1 && idx !== 1 
          }"
        >
            <img :src="franquia.imagem" :alt="franquia.nome" class="franquia-img" />
            <div class="franquia-info">
            <h5 class="franquia-nome">{{ franquia.nome }}</h5>
            <p class="franquia-desc">{{ franquia.descricao }}</p>
          </div>
        </div>
      </div>
      <button class="carousel-btn-elegante ms-4" @click="nextFranquia" aria-label="Próximo">
        <i class="fas fa-chevron-right"></i>
      </button>
    </div>
    <span
      v-for="(franquia, index) in franquias"
      :key="index"
      :class="{ active: index === franquiaAtual }"
      @click="franquiaAtual = index"
    ></span>
  </div>
</section>

<section id="formulario" class="formulario-franqueado py-5">
  <div class="container">
    <h3 class="form-titulo mb-4">Insira os dados</h3>
    <form @submit.prevent="enviarFormulario">
      <div class="row mb-3">
        <div class="col-12 mb-2">
          <label for="nome" class="form-label">Nome</label>
          <input id="nome" type="text" class="form-control" placeholder="Digite seu nome" v-model="form.nome" />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12 mb-2">
          <label for="email" class="form-label">E-mail</label>
          <input id="email" type="email" class="form-control" placeholder="Digite seu e-mail" v-model="form.email" />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12 mb-2">
          <label for="telefone" class="form-label">Telefone</label>
          <input id="telefone" type="text" class="form-control" placeholder="Digite seu telefone" v-model="form.telefone" />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12 mb-2">
          <label for="cidade" class="form-label">Cidade</label>
          <input id="cidade" type="text" class="form-control" placeholder="Digite sua cidade" v-model="form.cidade" />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12 mb-2">
          <label for="mensagem" class="form-label">Mensagem</label>
          <textarea id="mensagem" class="form-control" rows="4" placeholder="Digite sua mensagem" v-model="form.mensagem"></textarea>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center">
          <button type="submit" class="btn btn-enviar">Envie sua mensagem</button>
        </div>
      </div>
      <div v-if="erro" class="alert alert-danger mt-3 text-center">
        {{ erro }}
      </div>
    </form>
  </div>
</section>
  <Footer />
  
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import Footer from "../components/Footer.vue";
import TopBar from "../components/TopBar.vue";

export default {
  name: "SejaFranqueado",
  components: {
    TopBar,
    Footer,
  },
    directives: {
    'show-on-scroll': {
      mounted(el) {
        el.classList.add('invisible');
        const observer = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting) {
            el.classList.add('show-scroll');
            observer.unobserve(el);
          }
        }, { threshold: 0.1 });
        observer.observe(el);
      }
    }
  },
  data() {
    return {
      form: {
        nome: "",
        email: "",
        telefone: "",
        cidade: "",
        mensagem: "",
      },
      erro: "",
      showModal: false,
      franquias: [
        {
          nome: "Franquia - Curitiba - PR",
          descricao: "Av. Vicente Machado, 2639",
          imagem: "assets/images/home-equity.png"
        },
        {
          nome: "Franquia - Zona Leste SP - Tatuape",
          descricao: "Rua Coelho Lisboa, 61 - 10 Andar Cj 101",
          imagem: "assets/images/fachada2.png"
        },
        {
          nome: "Franquia - Zona Sul SP Lapa",
          descricao: "Rua Pio XI, 743",
          imagem: "assets/images/fachada3.png"
        },
        // {
        //   nome: "Franquia Consórcio",
        //   descricao: "Planejamento inteligente",
        //   imagem: "assets/images/home-equity.png"
        // },
        //  {
        //   nome: "Franquia Teste",
        //   descricao: "Planejamento inteligente",
        //   imagem: "assets/images/home-equity.png"
        // }
      ],
      franquiaAtual: 0,
      cardsVisiveis: 3,
      textoCompleto: "Transforme o mercado com a Creditall.",
      textoDigitado: "",
      textoPotencialCompleto: "Alto potencial de ganhos mensais",
      textoPotencialDigitado: "",
    };
  },
  computed: {
    franquiasVisiveis() {
      const total = this.franquias.length;
      const cards = [];
      for (let i = 0; i < this.cardsVisiveis; i++) {
        cards.push(this.franquias[(this.franquiaAtual + i) % total]);
      }
      return cards;
    }
  },
  mounted() {
    this.typeWriter();
    this.atualizarCardsVisiveis();
    window.addEventListener('resize', this.atualizarCardsVisiveis);
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.atualizarCardsVisiveis);
  },
  methods: {
    typeWriter(i = 0) {
      if (i <= this.textoCompleto.length) {
        this.textoDigitado = this.textoCompleto.slice(0, i);
        setTimeout(() => this.typeWriter(i + 1), 55);
      } else {
        this.typeWriterPotencial();
      }
    },
    typeWriterPotencial(j = 0) {
      if (j <= this.textoPotencialCompleto.length) {
        this.textoPotencialDigitado = this.textoPotencialCompleto.slice(0, j);
        setTimeout(() => this.typeWriterPotencial(j + 1), 45);
      }
    },

    enviarFormulario() {
      for (const campo in this.form) {
        if (!this.form[campo]) {
          this.erro = "Por favor, preencha todos os campos antes de enviar.";
          return;
        }
      }

      axios.post(`https://siscredit.com.br/siscred/web_rest.php?email_franquia=true&nome=${this.form.nome}&email=${this.form.email}&telefone=${this.form.telefone}&celular=${this.form.celular}&fantasia=${this.form.fantasia}&cpf=${this.form.cpf}&uf=${this.form.uf}&cidade=${this.form.cidade}&site=${this.form.site}&mensagem=${this.form.mensagem}&check=${this.form.check}`)
        .then(resp => console.log(resp),
              Swal.fire(
              `Email Enviado!`,
              `Aguarde nosso retorno`,
              `success`
               )
            )
        .catch(err =>
            Swal.fire(
              `Email não Enviado!`,
              `erro interno ${err}`,
              `error`
      ));

      this.erro = "";
      this.showModal = true;
      for (const campo in this.form) {
        this.form[campo] = "";
      }
    },
    atualizarCardsVisiveis() {
      this.cardsVisiveis = window.innerWidth < 768 ? 1 : 3;
      },


        scrollParaFormulario() {
      const el = document.getElementById('formulario');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    },

    nextFranquia() {
      this.franquiaAtual = (this.franquiaAtual + 1) % this.franquias.length;
    },
    prevFranquia() {
      this.franquiaAtual = (this.franquiaAtual - 1 + this.franquias.length) % this.franquias.length;
    },
  },
};

</script>

<style scoped>
.hero-franqueado {
  background-image: url('/assets/images/templatefranqueados2.png');
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  padding: 100px 0 60px 0;
  display: flex;
  align-items: center;
  min-height: 700px;
  position: relative;
}
.hero-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0, 0, 0, 0.55);
  z-index: 1;
}


.hero-franqueado .container {
 position: relative;
  z-index: 2;
}

.row.align-items-center {
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
}
.titulo-franquia {
  color: #dcd8d8fa;
}
.titulo-valor {
  color: #dcd8d8fa;
}
.badge-purple {
  display: inline-block;
  background-color: #bf1b39;
  color: #fff;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 14px;
  margin-bottom: 15px;
}

.valor-destaque {
  color: #bf1b39;
  font-weight: bold;
}

.classic-title span {
  border-bottom: 2px solid #bf1b39;
  padding-bottom: 5px;
}

.btn-primary {
  background-color: #bf1b39;
  border: none;
}

.btn-primary:hover {
  background-color: #9f102a;
}

.col-lg-6.mb-4 {
  text-align: center;
}

.solucoes-franqueado {
  background: #fff;
}

.badge-info {
  background: #bf1b39;
  font-size: 16px;
  padding: 8px 18px;
  border-radius: 20px;
}

.titulo-principal {
  color: #000000e3;
  font-size: 2.2rem;
  font-weight: 700;
  line-height: 1.2;
}

.hashtag {
  display: inline-block;
  border: 1px solid #bf1b39;
  color: #bf1b39;
  border-radius: 20px;
  padding: 6px 20px;
  font-size: 18px;
  margin-top: 16px;
}

.img-circular {
  max-width: 380px;
  width: 100%;
  border-radius: 50%;
  box-shadow: 0 4px 24px rgba(0,0,0,0.08);
  background: #fff;
}

.btn-info {
  background: #bf1b39;
  color: #fff;
  border: none;
}

.btn-info:hover {
  background: #bf1b39;
  color: #fff;
}

@media (max-width: 991px) {
  .solucoes-franqueado .row {
    flex-direction: column-reverse;
    text-align: center;
  }
  .img-circular {
    margin-bottom: 24px;
  }
}
.jornada-empreendedora {
  background: linear-gradient(to bottom, #fff 80%, #eaeaea 100%);
}

.jornada-titulo {
  color: #211f1fe4;
  text-align: center;
  font-size: 2.2rem;
  font-weight: 600;
}

.jornada-card {
  background: #ffffffb4;
  color: #080808;
  border-radius: 14px;
  border: 2px solid #847e8051;
  padding: 18px 10px 14px 10px;
  text-align: left;
  min-height: 150px;
  max-height: 150px;
  min-width: 240px;
  max-width: 240px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; 
  box-shadow: 0 4px 18px rgba(0,0,0,0.10);
  transition: box-shadow 0.3s, transform 0.3s;
  box-sizing: border-box;
}
.jornada-card h5 {
  font-size: 1rem;
  font-weight: 600;
  margin-top: -2px;
  margin-bottom: 4px;
}

.jornada-card p {
  font-size: 0.92rem;
  margin-bottom: 0;
}

.jornada-icon {
  font-size: 1.2rem;
  margin-bottom: 8px;
}

.jornada-icon i {
  color: #fff;
}
.jornada-card:hover {
  box-shadow: 0 8px 32px rgba(191,27,57,0.13), 0 2px 8px rgba(0,0,0,0.10);
  transform: translateY(-4px) scale(1.03);
}

@media (max-width: 991px) {
  .jornada-card {
    min-height: 140px;
    padding: 20px 10px;
    text-align: center;
  }
  .jornada-titulo {
    font-size: 1.4rem;
  }
}

@media (max-width: 767px) {
  .jornada-empreendedora .container {
    padding-left: 16px !important;
    padding-right: 16px !important;
    max-width: 100% !important;
  }
  
  .jornada-empreendedora .row {
    margin-left: 0 !important;
    margin-right: 0 !important;
    gap: 16px !important;
    justify-content: center !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    width: 100% !important;
  }
  
  .jornada-empreendedora .col-md-3,
  .jornada-empreendedora .col-6 {
    width: 100% !important;
    max-width: 100% !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    flex: none !important;
  }
  
  .jornada-card {
    min-width: 300px !important;
    max-width: 300px !important;
    width: 300px !important;
    min-height: 160px !important;
    max-height: 160px !important;
    margin: 0 auto 12px auto !important;
    padding: 18px 12px !important;
    text-align: center !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
    align-items: center !important;
    box-sizing: border-box !important;
    font-size: 1rem !important;
    overflow: hidden !important;
  }
  
  .jornada-card h5 {
    font-size: 1.1rem !important;
    margin-top: 0 !important;
    margin-bottom: 8px !important;
    text-align: center !important;
    line-height: 1.2 !important;
    flex-shrink: 0 !important;
  }
  
  .jornada-card p {
    font-size: 0.9rem !important;
    margin-bottom: 0 !important;
    text-align: center !important;
    line-height: 1.3 !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    display: -webkit-box !important;
    -webkit-line-clamp: 2 !important;
    -webkit-box-orient: vertical !important;
  }
  
  .jornada-icon {
    font-size: 1.3rem !important;
    margin-bottom: 10px !important;
    flex-shrink: 0 !important;
  }
  
  .jornada-titulo {
    font-size: 1.6rem !important;
    margin-bottom: 32px !important;
  }
}
.porque-franqueado {
  background: #f7f7f7;
}

.img-franqueado {
  max-width: 380px;
  width: 100%;
  border-radius: 18px;
  box-shadow: 0 4px 24px rgb(255, 255, 255);
}

.badge-success {
  background: #bf1b39;
  color: #fff;
  font-size: 16px;
  padding: 8px 18px;
  border-radius: 20px;
}

.porque.titulo {
  color: #bf1b39;
  font-size: 2.1rem;
  font-weight: 700;
}

.porque-desc {
  color: #0e0e0eb4;
  font-size: 1.1rem;
}

.porque-lista {
  list-style: none;
  padding-left: 0;
  margin-top: 0 0 0 0;
}

.porque-lista li {
  font-size: 1.08rem;
  margin-bottom: 12px;
  color: #080808b3;
  display: flex;
  align-items: center;
  gap: 7px;
}

.porque-lista li i {
  color: #bf1b39 !important;
  font-size: 1.2rem;
  flex-shrink: 0;
  display: inline-block;
}

.texto-item {
  flex: 1;
}

.btn-info {
  background: #bf1b39;
  color: #fff;
  border: none;
}

.btn-info:hover {
  background: #bf1b39;
  color: #fff;
}

@media (max-width: 991px) {
  .porque-franqueado .row {
    flex-direction: column-reverse;
    text-align: center;
  }
  .img-franqueado {
    margin-bottom: 24px;
  }
}
.mercado-potencial {
  background: #f7f7f7;
}
.badge-potencial {
  background: #bf1b39;
  color: #f7f7f7;
  font-size: 16px;
  padding: 8px 18px;
  border-radius: 20px;
  display: inline-block;
  margin-bottom: 12px;
}
.potencial-lista {
  list-style: disc;
  padding-left: 20px;
  color: #bf1b39;
  margin-bottom:24px;
  text-align: left;
}
.potencial-lista li {
  font-size: 1.08rem;
  margin-bottom: 8px;
}
.img-mapa-brasil {
  max-width: 420%;
  width: 100%;
  margin: 0 auto;
  display: block;
}

@media (max-width: 991px) {
  .mercado-potencial .row {
    flex-direction: column-reverse;
    text-align: center;
  }
  .img-mapa-brasil {
    margin-bottom: 24px;
  }
}
.formulario-franqueado {
  background: linear-gradient(to bottom, #e1ddddbf 75%, #f7f7f7 100%);
  border-radius: 18px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.08);
  padding: 40px 24px;
  max-width: 600px;
  margin: 40px auto;
}

.form-titulo {
  font-size: 2rem;
  font-weight: 500;
  color: #bf1b39;
  border-bottom: 2px solid #bf1b39;
  display: inline-block;
  padding-bottom: 10px;
  margin-bottom: 32px;
  margin-left: 0;
}

.form-label {
  font-weight: 600;
  color: #4c4444;
  margin-bottom: 8px;
  font-size: 1.05rem;
}

.form-control {
  border-radius: 8px;
  border: 1.9px solid #d1d1d1;
  font-size: 0.80rem;
  padding: 8px 10px;
  background: #ffffff;
  color: #222;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  margin-bottom: 5px;
  transition: border-color 0.4s;
}

.form-control:focus {
  border-color: #bf1b39;
  outline: none;
}

.btn-enviar {
  background: #bf1b39e8;
  color: #fff;
  border: none;
  padding: 14px 38px;
  border-radius: 8px;
  font-size: 1.10rem;
  font-weight: 600;
  margin-top: 18px;
  box-shadow: 0 2px 8px rgba(191,27,57,0.09);
  transition: background 0.4s;
}

.btn-enviar:hover {
  background: #9f102a;
  color: #fff;
}

.alert-danger {
  background: #ffeaea;
  color: #bf1b39;
  border: 1px solid #bf1b39;
  border-radius: 6px;
  font-weight: 500;
}
html {
  scroll-behavior: smooth;
}

#formulario {
  scroll-margin-top: 100px;
}
.modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.modal-content {
  background: #fff;
  border-radius: 12px;
  padding: 32px 28px 24px 28px;
  box-shadow: 0 4px 32px rgba(0,0,0,0.18);
  text-align: center;
  min-width: 280px;
}
.modal-content p {
  font-size: 1.15rem;
  color: #bf1b39;
  margin-bottom: 22px;
  font-weight: 600;
}


.franquias-creditall {
  background: #f7f7f7;
}

.franquias-titulo {
  color: #211f1fe4;
  text-align: center;
  font-size: 2.2rem;
  font-weight: 600;
}

.fraquias-destaque {
  color: #bf1b39;
}

.carousel-container {
  max-width: 800px;
  margin: 0 auto;
}

.carousel-btn {
  background: #b0adad;
  color: #fff;
  border: none;
  font-size: 1rem;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  cursor: pointer;
  transition: background 0.5s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-btn:hover {
  background: #9f102a;
}

.franquia-card {
  background: #fff;
  border-radius: 18px;
  padding: 32px 24px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.12);
  margin: 0 auto;
  min-width: 240px;
  max-width: 240px;
  min-height: 320px;
  max-height: 320px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  overflow: hidden;
}
.franquia-img {
  max-width: 180px;
  width: 100%;
  height: 120px;
  object-fit: contain;
  margin-bottom: 16px;
  border-radius: 18px;
}
@media (max-width: 768px) {
  .franquia-img {
    max-width: 140px;
    height: 90px;
    border-radius: 14px;;
  }
}
.franquia-info {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
}
.franquia-nome {
  min-height: 24px;
  margin-bottom: 8px;
  font-size: 1.1rem;
}
.franquia-desc {
  flex: 1 1 auto;
  min-height: 40px;
  max-height: 80px;
  font-size: 0.95rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media (max-width: 768px) {
  .carousel-container {
    overflow: hidden;
    width: 100%;
    max-width: 100%;
    margin-left: 0;
    margin-right: 0;
    padding: 0 8px;
  }
  .carousel-slide {
    display: flex;
    transition: transform 0.5s cubic-bezier(0.4,0,0.2,1), opacity 0.7s cubic-bezier(0.4,0,0.2,1);
    will-change: transform, opacity;
    width: 100%;
    justify-content: flex-start;
    align-items: stretch;
  }
  .franquia-card {
    min-width: 70vw;
    max-width: 70vw;
    min-height: 260px;
    max-height: 260px;
  }
  .franquia-img {
    max-width: 90px;
    height: 60px;
  }
  .carousel-btn {
    width: 45px;
    height: 45px;
    font-size: 1.5rem;
  }
  .franquia-card {
    padding: 24px 16px;
  }
  .franquia-img {
    max-width: 220px;
  }
  .franquias-titulo {
    font-size: 1.8rem;
  }
  .carousel-container .carousel-btn-elegante.me-4 {
    margin-right: 5px !important;
  }
  .carousel-container .carousel-btn-elegante.ms-4 {
    margin-left: 5px !important;
  }
  .formulario-franqueado {
    max-width: 350px;
    width: 95vw;
    padding: 20px 8px;
    margin: 24px auto;
    border-radius: 12px;
  }
}

.franquia-card {
  transition: 
    transform 0.6s cubic-bezier(0.4, 0, 0.2, 1),
    box-shadow 0.6s cubic-bezier(0.4, 0, 0.2, 1),
    border 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}
.franquia-card.destaque {
  transform: scale(1.12);
  box-shadow: 0 12px 48px rgba(191,27,57,0.18), 0 2px 8px rgba(0,0,0,0.10);
  border: 2.5px solid #bf1b39;
  z-index: 2;
}

.carousel-fade-enter-active, .carousel-fade-leave-active {
  transition: opacity 0.7s cubic-bezier(0.4, 0, 0.2, 1);
}
.carousel-fade-enter-from, .carousel-fade-leave-to {
  opacity: 0;
}

.carousel-btn-elegante {
  background: transparent;
  color: #bf1b39;
  border: none;
  font-size: 2.2rem;
  border-radius: 0;
  width: auto;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: none;
  transition: color 0.3s, transform 0.2s;
  cursor: pointer;
  outline: none;
  position: relative;
  z-index: 3;
}
.carousel-btn-elegante:hover, .carousel-btn-elegante:focus {
  color: #9f102a;
  background: transparent;
  box-shadow: none;
  transform: scale(1.18);
}
.blur-card {
  filter: blur(2.5px) grayscale(30%);
  opacity: 0.7;
  transition: filter 0.4s, opacity 0.4s;
  pointer-events: none;
}
.texto-vermelho {
  color: #bf1b39;
  font-weight: bold;
  font-size: 1.4rem;
}

.texto-branco {
  color: #fff;
}
.invisible {
  opacity: 0;
  transform: translateY(40px);
  transition: opacity 0.7s cubic-bezier(0.4,0,0.2,1), transform 0.7s cubic-bezier(0.4,0,0.2,1); 
}

.show-scroll {
  opacity: 1;
  transform: translateY(0);
}
.unidades-creditall {
  background: #f7f7f7;
}
.badge-unidades {
  color: rgb(25, 24, 24) !important;
  font-weight: 600;
  display: inline-block;
  padding: 8px 18px;
  border-radius: 30px;
  border: 2px solid #bf1b39;
  box-shadow: 0 4px 12px rgba(0,0,0,0.06);
  font-size: 0.70rem;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}
.video-responsive {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  width: 100%;
  max-width: 100%;
}

.video-responsive iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
</style>
